// Constants
import { AppContext } from "@ms/uno-constants/lib/local/configuration/AppContext";
import { ContentLinkType } from "../service/planner/enumerations/IPlannerEnumerations";
/** Returns whether the task has a connected plan exposed by the service-backed field. */ export const hasTaskConnectedPlan = (task)=>connectedPlanIdsEnabled() && !!task?.connectedPlanIds.length;
/** Returns the service-backed connected plan ID when the field is enabled. */ export const getConnectedPlanId = (task)=>connectedPlanIdsEnabled() ? task.connectedPlanIds[0] ?? null : null;
/** Returns all of the plan's parent-task PLinks, i.e. the master tasks this plan is connected to. */ export const getPlanParentTaskPLinks = (links)=>links.filter(isPlanParentTaskPLink);
/** Returns whether a ParentTask PLink points to the given task, independent of URL origin. */ export const isParentTaskPLinkForTask = (link, planId, taskId)=>{
    const routeIds = getPLinkRoute(link.webUrl);
    return isPlanParentTaskPLink(link) && routeIds?.planId === planId && routeIds.taskId === taskId;
};
/**
 * Parses a PLink deep-link webUrl into its route identifiers.
 * Recognizes an absolute `.../plan/{planId}[/.../task/{taskId}]` URL from any origin, tolerating
 * query/hash suffixes and URL-encoded segments. Returns `null` when no plan segment is present, and
 * swallows malformed input (e.g. an invalid percent-encoding that would throw during decoding) as `null`.
 */ export const getPLinkRoute = (webUrl)=>{
    try {
        const url = new URL(webUrl);
        const pathSegments = url.pathname.split("/").filter(Boolean);
        const planSegmentIndex = pathSegments.findIndex((segment)=>segment.toLowerCase() === "plan");
        const taskSegmentIndex = pathSegments.findIndex((segment, index)=>index > planSegmentIndex + 1 && segment.toLowerCase() === "task");
        const encodedPlanId = planSegmentIndex >= 0 ? pathSegments[planSegmentIndex + 1] : undefined;
        const encodedTaskId = taskSegmentIndex >= 0 ? pathSegments[taskSegmentIndex + 1] : undefined;
        if (taskSegmentIndex >= 0) {
            url.pathname = `/${pathSegments.slice(0, taskSegmentIndex).join("/")}`;
            url.search = "";
            url.hash = "";
        }
        return encodedPlanId ? {
            planId: decodeURIComponent(encodedPlanId),
            taskId: encodedTaskId ? decodeURIComponent(encodedTaskId) : null,
            planUrl: taskSegmentIndex >= 0 ? url.toString() : webUrl
        } : null;
    } catch  {
        return null;
    }
};
/** Returns the plan ID encoded in a PLink web URL. */ export const getConnectedPlanIdFromPLinkUrl = (webUrl)=>getPLinkRoute(webUrl)?.planId ?? null;
/** Returns the master task ID encoded in a plan's parent-task PLink web URL. */ export const getTaskIdFromPlanParentTaskPLink = (link)=>isPlanParentTaskPLink(link) ? getPLinkRoute(link.webUrl)?.taskId ?? null : null;
// Returns whether the connectedPlanIds field is enabled
const connectedPlanIdsEnabled = ()=>AppContext.appConfiguration?.flights.EnableConnectedPlanIds === true;
/** Checks whether a web-reference link targets a Planner task. */ const isPlanParentTaskPLink = (link)=>link.linkType === ContentLinkType.WebReference && getPLinkRoute(link.webUrl)?.taskId != null;
